<template>
  <div id="app">
    <header>
      <nav class="navbar has-shadow is-light" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <a class="navbar-item">
            <router-link tag="a" to="/" class="navbar-item">
              <img src="./assets/logo.png" width="160" height="28" alt="Charltons">
            </router-link>
          </a>

          <a role="button" aria-label="menu" aria-expanded="false"
            :class="['navbar-burger', showMobileMenu ? 'is-active' : '']"
            @click.prevent="showMobileMenu = !showMobileMenu"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div
          :class="['navbar-menu', showMobileMenu ? 'is-active' : '']"
          v-if="$auth.check()"
        >
          <div class="navbar-end">
            <router-link to="/" class="navbar-item">New</router-link>

            <div class="navbar-item has-dropdown is-hoverable">
              <router-link to="/list" class="navbar-link">Forms</router-link>
              <div class="navbar-dropdown is-boxed">
                <router-link to="/list/1" class="navbar-item">Pending</router-link>
                <router-link to="/list/10" class="navbar-item">
                  <div>Submitted</div>
                  <b-tag v-if="$store.state.submittedFormsQty" rounded type="is-danger">
                    {{ $store.state.submittedFormsQty }}
                  </b-tag>
                </router-link>
                <router-link to="/list" class="navbar-item">All</router-link>
              </div>
            </div>

            <router-link to="/admin" class="navbar-item"
              v-if="$auth.check('superadmin')">Admin</router-link>
            <a class="navbar-item"
              @click.prevent="$auth.logout({ redirect: { name: 'login' } })"
              v-if="$auth.check()"
            >Logout</a>
          </div>
        </div>
      </nav>
    </header>
    <main class="container is-fluid">
      <router-view
        class="column is-10 is-offset-1"
        v-if="$auth.ready()"
        :key="$route.fullPath"
      />
    </main>
  </div>
</template>

<script>
import '@mdi/font/css/materialdesignicons.min.css'

export default {
  name: 'app',
  data () {
    return {
      showMobileMenu: false
    }
  },
  updated () {
    this.$store.dispatch('getSubmittedFormsQty')
  }
}
</script>

<style>
.navbar-item .tag {
  height: 1.5em;
  padding-left: 0.45em;
  padding-right: 0.45em;
  margin-left: 0.5em;
}
</style>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #167df0;
$primary-invert: findColorInvert($primary);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
